import React from 'react';
import PropTypes from 'prop-types';
import { Text, Title, Icon } from 'components';
import checkSprite from 'assets/icons/check.svg';
import {
  VideoInfoHeaderStyled,
  IconWrap,
  TextWrap,
  TitleWrap,
  ExpirationDate,
  Extra,
  SaleModel,
  SaleModelInnerWrap,
  SaleModelTextWrap,
  SaleModelWrap,
} from './styles/VideoInfoHeaderStyled';

const VideoInfoHeader = ({
  title,
  year,
  genre,
  bySubscription,
  buyFrom,
  purchasedIcon,
  isDTOBought,
  isTVODBought,
  isSVODBought,
  expirationDate,
  translate,
  assignTitleRef,
}) => {
  const notDTOorTVODBought = !isDTOBought && !isTVODBought;
  const isDTOorTVODandSVODBought = (isDTOBought || isTVODBought) && isSVODBought;
  return (
    <VideoInfoHeaderStyled>
      <TitleWrap>
        <Title getRef={assignTitleRef} size="fs_xxl">
          {title}
        </Title>
      </TitleWrap>
      <Extra>
        <SaleModelWrap>
          <SaleModelTextWrap>
            <Text color="gray" size="fs_xxs">{`${year}, ${genre}`}</Text>
          </SaleModelTextWrap>
          <SaleModel>
            {(notDTOorTVODBought || isDTOorTVODandSVODBought) &&
              bySubscription && (
                <SaleModelInnerWrap>
                  {purchasedIcon && (
                    <IconWrap>
                      <Icon name={checkSprite.id} size={16} color="orange" />
                    </IconWrap>
                  )}
                  <TextWrap>
                    <Text font="din_bold" type="uppercase" color="orange" size="fs_xxs">
                      {bySubscription}
                    </Text>
                  </TextWrap>
                  {purchasedIcon &&
                    expirationDate && (
                      <ExpirationDate>
                        <Text font="din_bold" type="uppercase" color="gray" size="fs_xxs">
                          {`${translate('embed.to')} ${expirationDate}`}
                        </Text>
                      </ExpirationDate>
                    )}
                </SaleModelInnerWrap>
              )}
            {!isSVODBought &&
              buyFrom && (
                <SaleModelInnerWrap>
                  {purchasedIcon && (
                    <IconWrap>
                      <Icon name={checkSprite.id} size={16} color="turquoise" />
                    </IconWrap>
                  )}
                  <TextWrap>
                    <Text font="din_bold" type="uppercase" color="turquoise" size="fs_xxs">
                      {buyFrom}
                    </Text>
                  </TextWrap>
                </SaleModelInnerWrap>
              )}
          </SaleModel>
        </SaleModelWrap>
      </Extra>
    </VideoInfoHeaderStyled>
  );
};

VideoInfoHeader.propTypes = {
  title: PropTypes.string.isRequired,
  year: PropTypes.string,
  genre: PropTypes.string,
  expirationDate: PropTypes.string,
  bySubscription: PropTypes.string,
  buyFrom: PropTypes.string,
  purchasedIcon: PropTypes.bool,
  isDTOBought: PropTypes.bool,
  isTVODBought: PropTypes.bool,
  isSVODBought: PropTypes.bool,
  translate: PropTypes.func,
  assignTitleRef: PropTypes.func,
};

VideoInfoHeader.defaultProps = {
  year: '',
  genre: '',
  bySubscription: '',
  expirationDate: null,
  buyFrom: '',
  purchasedIcon: false,
  isDTOBought: false,
  isTVODBought: false,
  isSVODBought: false,
  translate: Function.prototype,
  assignTitleRef: Function.prototype,
};

export default VideoInfoHeader;
